export default __webpack_public_path__ + "static/graphik-web-semibold-c1bef79a1693e86e34425151185d50b8.woff";